import { createSlice } from '@reduxjs/toolkit';

export const projectSliceName = 'project';

export const projectInitialState = {
  checklist: [],
  checklistOptions: [],
  payments: [],
  projectTypeActive: '',
  projectTypeActiveHash: '',
  projectsTypes: [],
  projectsDetails: {}
};

export const projectSlice = createSlice({
  name: projectSliceName,
  initialState: projectInitialState,
  reducers: {
    setChecklist: (state, action) => {
      state.checklist = action.payload;
      state.checklistOptions = [];
    },
    setChecklistOptions: (state, actions) => {
      const checklistItemId = actions.payload.id;
      const checklistItemOptions = actions.payload.options;
      const checklistItemIndex = state.checklist.findIndex(checklistItem => checklistItem.id === checklistItemId);

      state.checklist[checklistItemIndex] = {
        ...state.checklist[checklistItemIndex],
        options: checklistItemOptions
      };
    },
    setChecklistOptionsChecked: (state) => {
      let isStaticChecked = false; //for banners
      let isAnimatedChecked = false; //for banners
      state.checklistOptions = state.checklist['reduce']((accumulator, currentValue) => {

        const optionList = currentValue.options.filter(option => option.isChecked);

        /// some hardcode for banners bug begin
        // 1657219942514 - Static
        // 1657219942940 - Simple Animation
        // 1657219943365 - Complex Animation
        // 1657219943770 - Interactive
        // 1657220096093 - Cycled animation
        // 1657220096380 - Animation reload
        optionList.map(option => {
          if (option.id === 1657219942514 && option.isChecked === true) {
            isStaticChecked = true;
          }
          if ((option.id === 1657219942940 || option.id === 1657219943365 || option.id === 1657219943770) && option.isChecked === true) {
            isAnimatedChecked = true;
          }
        });
        const optionList2 = optionList.filter(
            option => (!((option.id === 1657220096093 || option.id === 1657220096380) && (isStaticChecked && !isAnimatedChecked)))
        );
        /// some hardcode for banners bug end

        const optionType = currentValue.optionsType;
        const optionTypeIgnore = 'TEXT';

        accumulator = [
          ...accumulator,
          ...(optionType === optionTypeIgnore ? [] : optionList2) /* without hardcore use optionList*/
        ];

        return accumulator;
      }, []);
    },
    setChecklistOptionsDisabled: (state) => {
      const disabledIdsOptions = state.checklistOptions.filter(option => option.disableIds && option.disableIds.length);
      const disabledIds = disabledIdsOptions['reduce']((accumulator, currentValue) => {
        accumulator = [
          ...accumulator,
          ...currentValue['disableIds']
        ]
        return accumulator;
      }, []);

      // banners begin
      const disableIdsInactiveWithOptions = state.checklistOptions.filter(option => option.disableIdsInactiveWith && option.disableIdsInactiveWith.length);

      const disableInactiveIds = disableIdsInactiveWithOptions['reduce']((accumulator, currentValue) => {
        accumulator = [
          ...accumulator,
          ...currentValue['disableIdsInactiveWith']
        ]
        return accumulator;
      }, []);

      let isAllowDisabling = true;
      // banners end

      state.checklist = state.checklist.map((checklistItem) => {
        if (checklistItem.options && checklistItem.options.length) {

          // banners begin
          checklistItem.options.map((option) => ({...option})).forEach(item => {
            disableInactiveIds.forEach((element) => {
              if (item.id === element) {
                if (item.isChecked) {
                  isAllowDisabling = false;
                }
              }
            });
          });
          // banners end

          return {
            ...checklistItem,
            options: checklistItem.options.map((option) => ({
              ...option,
              isDisabled: (disabledIds.includes(option.id) && isAllowDisabling)
            }))
          }
        }
        return checklistItem;
      });
    },
    setPayments: (state, action) => {
      state.payments = action.payload;
    },
    setProjectType: (state, action) => {
      state.projectTypeActive = action.payload;
    },
    setProjectTypeHash: (state, action) => {
      state.projectTypeActiveHash = action.payload;
    },
    setProjectsTypes: (state, action) => {
      state.projectsTypes = action.payload;
    },
    setProjectsDetails: (state, action) => {
      state.projectsDetails = action.payload;
    }
  }
});

export const {
  setChecklist,
  setChecklistOptions,
  setChecklistOptionsChecked,
  setChecklistOptionsDisabled,
  setPayments,
  setProjectType,
  setProjectTypeHash,
  setProjectsTypes,
  setProjectsDetails,
} = projectSlice.actions;

export default projectSlice.reducer;
